"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Immutably removes an item at the specified index of the array
 * 
 * @category Array
 * @param {array} array - The original array
 * @param {number} index - The index to remove
 * @returns {array} - The new array
 * @example
 * const array = ['dog', 'cat', 'bird'];
 * const newArray = removeAt(array, 1);
 * // => ['dog', 'bird']
 */
var _default = function _default(array, index) {
  if (array === undefined || array === null || array.length <= 0 || index < 0 || array.length <= index) return array;
  return array.slice(0, index).concat(array.slice(index + 1));
};

exports.default = _default;